// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_UoykU","maskContent":"index_maskContent_NxoGK"};